"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * zwraca maksymalną wartość
 * @param values tablica wartości
 */
function max(values) {
    var result = values[0];
    var i = values.length;
    while (--i > 0) {
        if (values[i] > result) {
            result = values[i];
        }
    }
    return result;
}
exports.default = max;
//# sourceMappingURL=max.js.map